import { openDB } from 'idb';

const DB_NAME    = 'datofy-scanner';
const DB_VERSION = 1;

let dbPromise = null;

export const getDB = () => {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        // Cache de alumnos: token UUID → datos del alumno
        if (!db.objectStoreNames.contains('students_cache')) {
          const store = db.createObjectStore('students_cache', { keyPath: 'token' });
          store.createIndex('rut',        'rut');
          store.createIndex('wp_user_id', 'wp_user_id');
        }

        // Cola de accesos offline pendientes de sincronizar
        if (!db.objectStoreNames.contains('offline_queue')) {
          const queue = db.createObjectStore('offline_queue', {
            keyPath: 'local_id', autoIncrement: true,
          });
          queue.createIndex('synced',    'synced');
          queue.createIndex('scanned_at','scanned_at');
        }
      },
    });
  }
  return dbPromise;
};

// ─── Students Cache ───────────────────────────────────────────────────────────

export const getStudentByToken = async (token) => {
  const db = await getDB();
  return db.get('students_cache', token);
};

export const putStudents = async (students) => {
  const db = await getDB();
  const tx = db.transaction('students_cache', 'readwrite');
  await Promise.all([
    ...students.map(s => tx.store.put(s)),
    tx.done,
  ]);
};

export const getCacheSize = async () => {
  const db = await getDB();
  return db.count('students_cache');
};

export const clearStudentsCache = async () => {
  const db = await getDB();
  return db.clear('students_cache');
};

// ─── Offline Queue ────────────────────────────────────────────────────────────

export const addToQueue = async (logData) => {
  const db = await getDB();
  return db.add('offline_queue', { ...logData, synced: 0 });
};

export const getPendingQueue = async () => {
  const db = await getDB();
  return db.getAllFromIndex('offline_queue', 'synced', 0);
};

export const getPendingCount = async () => {
  const db = await getDB();
  return db.countFromIndex('offline_queue', 'synced', 0);
};

export const markAllSynced = async (localIds) => {
  if (!localIds.length) return;
  const db = await getDB();
  const tx = db.transaction('offline_queue', 'readwrite');
  await Promise.all([
    ...localIds.map(async id => {
      const item = await tx.store.get(id);
      if (item) tx.store.put({ ...item, synced: 1 });
    }),
    tx.done,
  ]);
};
